@if (isEnabled && navigationHandler.isInitialized()) {
  @if (!isOpen()) {
    <button
      class="wattson-fab"
      (click)="open()"
      [attr.aria-label]="'wattson.open_aria' | translate"
    >
      <span class="wattson-fab-inner">
        <mat-icon class="wattson-fab-spark">auto_awesome</mat-icon>
        <span class="wattson-fab-label">Wattson</span>
      </span>
    </button>
  }

  <div class="wattson-chat" [class.wattson-chat--open]="isOpen()">
    <div class="wattson-header">
      <mat-icon class="wattson-header-icon">electric_bolt</mat-icon>
      <span class="wattson-title">{{ 'wattson.title' | translate }}</span>
      @if (highlightHandler.activeHighlight()) {
        <button
          class="wattson-highlight-toggle-btn"
          (click)="highlightHandler.toggleHighlighting()"
          [attr.aria-label]="
            (highlightHandler.isHighlightingEnabled()
              ? 'wattson.disable_highlight'
              : 'wattson.enable_highlight'
            ) | translate
          "
        >
          <mat-icon>{{
            highlightHandler.isHighlightingEnabled() ? 'visibility' : 'visibility_off'
          }}</mat-icon>
          <span>{{
            (highlightHandler.isHighlightingEnabled()
              ? 'wattson.disable_highlight'
              : 'wattson.enable_highlight'
            ) | translate
          }}</span>
        </button>
      }
      <button
        mat-icon-button
        class="wattson-close-btn"
        (click)="close()"
        [attr.aria-label]="'wattson.close_aria' | translate"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="wattson-messages" #messageList>
      @for (message of aiStore.messages(); track $index) {
        <div
          class="message-tile"
          [class.message-tile--user]="message.role === 'user'"
          [class.message-tile--assistant]="message.role === 'assistant'"
        >
          @if (message.loading) {
            <span class="loading-dots"> <span></span><span></span><span></span> </span>
          } @else {
            <markdown [data]="message.text" />
          }
        </div>
      }
      @if (aiStore.messages().length === 0) {
        <p class="wattson-empty">{{ 'wattson.empty_state' | translate }}</p>
      }
    </div>

    <div class="wattson-input-area">
      <input
        class="wattson-input"
        type="text"
        [(ngModel)]="inputText"
        (keydown)="onKeyDown($event)"
        [placeholder]="'wattson.input_placeholder' | translate"
        [disabled]="aiStore.isLoading()"
        [attr.aria-label]="'wattson.input_aria' | translate"
      />
      <button
        mat-icon-button
        class="wattson-send-btn"
        (click)="sendMessage()"
        [disabled]="aiStore.isLoading() || !inputText.trim()"
        [attr.aria-label]="'wattson.send_aria' | translate"
      >
        <mat-icon>send</mat-icon>
      </button>
    </div>
  </div>
}
